import { cmApi, type SecurityLoginFromBlockedRow } from '@/api/cmApi'
import { SecurityCrudPage } from './SecurityCrudPage'

export function LoginFromBlockedIpPage() {
  return (
    <SecurityCrudPage<SecurityLoginFromBlockedRow>
      title="Login from blocked IP"
      subtitle="Audit when players hit a blocked IP or device"
      queryKey="login-from-blocked-ip"
      emptyHint="No audit rows yet. Populated when players log in from a blocked IP/device (Player-API → CM-API)."
      listFn={cmApi.securityLoginFromBlockedList}
      columns={[
        { key: 'user', header: 'Username', cell: (r) => r.username ?? '—' },
        { key: 'ip', header: 'IP', cell: (r) => r.ip ?? '—' },
        { key: 'device', header: 'Device', cell: (r) => r.deviceId ?? '—' },
        { key: 'msg', header: 'Message', cell: (r) => r.message ?? '—' },
        {
          key: 'when',
          header: 'When',
          cell: (r) => new Date(r.createdAt).toLocaleString(),
        },
      ]}
    />
  )
}
